import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadModalComponent } from './upload-modal.component';

@Injectable({
  providedIn: 'root',
})
export class UploadModalService {
  constructor(private ngbModal: NgbModal) {}

  open(props: any): Promise<any> {
    const modalRef = this.ngbModal.open(UploadModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
    });
    return modalRef.result;
  }
}
